(function () {
	'use strict';
	var queue = [];

	theme.omaValinta = {
		elements: {
			omavalintaHeader: document.getElementById('omavalinta-header'),
			omavalintaFooter: document.getElementById('omavalinta-footer'),
			selectedProductQty: document.getElementById('selected-product-count'),
			selectedItems: document.getElementById('selected-items'),
			productsTotal: document.getElementById('omavalinta-total'),
			omaValintaATC: document.getElementById('ov-add-to-cart'),
			footerPersonCount: document.getElementById('person-count'),
			footerTextFoodCount: document.getElementById('food-count-text'),
			footerTextPersonCount: document.getElementById('person-count-text'),
			floatingCart: document.getElementById('omavalinta-floating-total'),
			floatingCartTotalQty: document.getElementById('floating-total-qty'),
			floatingCartPeople: document.getElementById('floating-people-count'),
			floatingCartPrice: document.getElementById('floating-total-price'),
		},
		init: function () {
			var collectionTriggers = document.getElementsByClassName('collapsible-trigger');
			[...collectionTriggers].forEach((trigger) => {
				var opened = false;
				trigger.addEventListener('click', function () {
					var openedText = this.querySelector('#open-close');
					if (opened == true) {
						openedText.innerHTML = 'Näytä';
						opened = false;
					} else {
						openedText.innerHTML = 'Sulje';
						opened = true;
					}
				});
			});

			var btns = document.querySelectorAll('button[data-id]');
			[...btns].forEach((btn) =>
				btn.addEventListener('click', function () {
					var btnDataID = btn.getAttribute('data-id');
					var collectionDivs = document.getElementsByClassName('omavalinta-collection');

					for (let i = 0; i < collectionDivs.length; i++) {
						var colDataID = collectionDivs[i].getAttribute('data-id');
						if (colDataID === btnDataID) {
							if (collectionDivs[i].style.display === 'none') {
								collectionDivs[i].style.display = 'block';
								this.classList.remove('btn--secondary');
							} else {
								collectionDivs[i].style.display = 'none';
								this.classList.add('btn--secondary');
							}
						}
					}
				})
			);

			window.valinnat = [];
			window.valinnatWithPersons = [];
			let globalPersonCount = '1';

			var qtySelectors = document.querySelectorAll('.quantity-selector-wrapper');
			[...qtySelectors].forEach((qtySel) =>
				qtySel.addEventListener('click', function (e) {
					var quantityInput = this.querySelector('span');
					var minusBtn = this.querySelector('button .js-qty__adjust--minus');
					var plusBtn = this.querySelector('button js-qty__adjust--plus');

					// console.log(quantityInput);
					e.preventDefault();
					var selectedQuantity = quantityInput.getAttribute('data-quantity');
					let currentQuantity = Number(selectedQuantity);
					var productPrice = qtySel.getAttribute('data-product-price');
					var productHandle = qtySel.getAttribute('data-product-handle');
					var productTitle = qtySel.getAttribute('data-product-title');
					var productID = qtySel.getAttribute('data-product-id');

					// console.log(qtySel);

					if (e.target.getAttribute('data-action') === 'increase') {
						++currentQuantity;
						window.valinnat.push({
							productID: productID,
							title: productTitle,
							handle: productHandle,
							price: productPrice,
						});
						// console.log(globalPersonCount);
						theme.omaValinta.updateValinnat(globalPersonCount);
					} else if (e.target.getAttribute('data-action') === 'reduce') {
						--currentQuantity;
						var index_of = window.valinnat.findIndex((x) => x.productID === productID);
						if (index_of < 0) {
							return;
						}
						window.valinnat.splice(index_of, 1);
						//console.log(globalPersonCount);
						theme.omaValinta.updateValinnat(globalPersonCount);
					}
					if (currentQuantity < 0) {
						currentQuantity = 0;
					}

					quantityInput.setAttribute('data-quantity', currentQuantity);
					quantityInput.innerHTML = currentQuantity;

					if (currentQuantity > 0) {
						this.parentNode.parentNode.classList.add('omavalinta--active');
					} else {
						this.parentNode.parentNode.classList.remove('omavalinta--active');
					}
				})
			);

			// Add to cart
			var uniqueItems = [];
			let personUniqueArray = [];

			theme.omaValinta.elements.omaValintaATC.addEventListener('click', function () {
				// console.log(valinnat.length);
				// console.log(globalPersonCount);

				if (Number(globalPersonCount) > 1) {
					if (valinnat.length < 7) {
						alert('Minimitilausmäärä 7 tuotetta.');
						return;
					} else {
						this.classList.add('btn--loading');
						personUniqueArray = [];
						window.valinnat.forEach(function (item) {
							var isMatch = personUniqueArray.findIndex((x) => x.productID == item.productID);
							if (isMatch < 0) {
								item.quantity = 1;
								personUniqueArray.push(item);
							} else {
								personUniqueArray[isMatch].quantity += 1;
							}
						});
						theme.omaValinta.updatePersonCount(globalPersonCount, personUniqueArray);
						theme.omaValinta.addToCart(personUniqueArray);
					}
				} else {
					if (valinnat.length < 14) {
						alert('Minimitilausmäärä kahdelle henkilölle on 14 tuotetta.');
					} else {
						this.classList.add('btn--loading');
						personUniqueArray = [];
						window.valinnat.forEach(function (item) {
							var isMatch = personUniqueArray.findIndex((x) => x.productID == item.productID);
							if (isMatch < 0) {
								item.quantity = 1;
								personUniqueArray.push(item);
							} else {
								personUniqueArray[isMatch].quantity += 1;
							}
						});
						theme.omaValinta.updatePersonCount(globalPersonCount, personUniqueArray);
						theme.omaValinta.addToCart(personUniqueArray);
					}
				}
			});

			// Person counter buttons
			var personBtns = document.querySelectorAll('button[data-person-count]');
			[...personBtns].forEach((btn) =>
				btn.addEventListener('click', function () {
					personUniqueArray = [];
					let personCount = btn.getAttribute('data-person-count');
					globalPersonCount = personCount;

					if (this.classList.contains('btn--secondary') === true) {
						[...personBtns].forEach((btn) => btn.classList.add('btn--secondary'));
						this.classList.remove('btn--secondary');
					}

					window.valinnat.forEach(function (item) {
						var isMatch = personUniqueArray.findIndex((x) => x.productID == item.productID);
						if (isMatch < 0) {
							item.quantity = 1;
							personUniqueArray.push(item);
						} else {
							personUniqueArray[isMatch].quantity += 1;
						}
					});
					theme.omaValinta.updatePersonCount(personCount, personUniqueArray);
				})
			);
		},
		addToCart: function (items) {
			if (items) {
				queue = items;
			}
			if (queue.length) {
				var r = queue.shift();
				// todo ruokailijoiden määrä
				var quantity = Math.round(r.quantity);
				theme.omaValinta.updateCart(r.productID, quantity, true, true);
			} else {
				document.location.href = '/cart';
			}
		},
		updateValinnat: function (personCount) {
			// console.log(personCount);
			if (personCount === '2') {
				theme.omaValinta.elements.selectedProductQty.innerHTML = (window.valinnat.length * personCount) / 2;
				theme.omaValinta.elements.footerTextFoodCount.innerHTML = (window.valinnat.length * personCount) / 2;
				theme.omaValinta.elements.floatingCartTotalQty.innerHTML = (window.valinnat.length * personCount) / 2;
			} else if (personCount === '3') {
				theme.omaValinta.elements.selectedProductQty.innerHTML = (window.valinnat.length * personCount) / 3;
				theme.omaValinta.elements.footerTextFoodCount.innerHTML = (window.valinnat.length * personCount) / 3;
				theme.omaValinta.elements.floatingCartTotalQty.innerHTML = (window.valinnat.length * personCount) / 3;
			} else {
				theme.omaValinta.elements.selectedProductQty.innerHTML = window.valinnat.length * personCount;
				theme.omaValinta.elements.footerTextFoodCount.innerHTML = window.valinnat.length * personCount;
				theme.omaValinta.elements.floatingCartTotalQty.innerHTML = window.valinnat.length * personCount;
			}
			theme.omaValinta.elements.selectedItems.innerHTML = '';

			var uniqueItems = [];
			var htmlElements = [];
			var priceInTotal = 0;
			var totalQuantity = 0;
			var totalPersonCount = personCount;

			window.valinnat.forEach(function (item) {
				var isMatch = uniqueItems.findIndex((x) => x.productID == item.productID);
				if (isMatch < 0) {
					item.quantity = 1;
					uniqueItems.push(item);
				} else {
					uniqueItems[isMatch].quantity += 1;
				}
			});
			// console.log(uniqueItems);

			/*## Checkkaa vanhasta koodista miten määritellään hinnat per ruokailija ##*/
			uniqueItems.forEach(function (item) {
				var price = theme.Currency.formatMoney(item.price, theme.settings.moneyFormat);
				var helperPrice = item.price;
				if (personCount === '2') {
					helperPrice = Number(helperPrice) * 2;
					helperPrice = theme.Currency.formatMoney(helperPrice, theme.settings.moneyFormat);
				} else if (personCount === '3') {
					helperPrice = Number(helperPrice) * 3;
					helperPrice = theme.Currency.formatMoney(helperPrice, theme.settings.moneyFormat);
				} else {
					helperPrice = price;
				}
				var helperQty = item.quantity * personCount;
				totalQuantity = item.quantity * personCount;
				var priceTotal = theme.Currency.formatMoney(item.price * helperQty, theme.settings.moneyFormat);
				priceInTotal += item.price * helperQty;
				var htmlItem =
					"<div class='line-item product'>" +
					"<span class='title'>" +
					item.title +
					'</span>' +
					"<span class='quantity'>" +
					item.quantity +
					' kpl' +
					'</span>' +
					"<span class='unit-price'>" +
					helperPrice +
					' / ruoka' +
					'</span>' +
					"<span class='price_total'>" +
					priceTotal +
					'</span>' +
					'</div>';
				htmlElements.push(htmlItem);
			});

			var cartHeader =
				"<div class='line-item'>" +
				"<span class='title'>" +
				'Tuote' +
				'</span>' +
				"<span class='quantity'>" +
				'Määrä' +
				'</span>' +
				"<span class='unit-price'>" +
				'Hinta' +
				'</span>' +
				"<span class='price_total'>" +
				'Yhteensä' +
				'</span>' +
				'</div>';
			theme.omaValinta.elements.selectedItems.innerHTML += cartHeader;
			htmlElements.forEach(function (html) {
				theme.omaValinta.elements.selectedItems.innerHTML += html;
			});

			priceInTotal = theme.Currency.formatMoney(priceInTotal, theme.settings.moneyFormat);
			theme.omaValinta.elements.productsTotal.innerHTML = priceInTotal;

			theme.omaValinta.elements.floatingCart.style.display = 'block';
			theme.omaValinta.elements.floatingCartPeople.innerHTML = totalPersonCount * 2;
			theme.omaValinta.elements.floatingCartPrice.innerHTML = priceInTotal;
		},
		updatePersonCount: function (personCount, personUniqueArray) {
			// console.log(personCount);
			var productListWithPersons = personUniqueArray;
			var priceInTotal = 0;
			var totalProductCount = 0;
			var htmlElements = [];
			var personUniqueArray = [];

			productListWithPersons.forEach(function (item) {
				item.quantity = item.quantity * personCount;
			});

			theme.omaValinta.elements.selectedItems.innerHTML = '';

			productListWithPersons.forEach(function (item) {
				var helperQuantity = item.quantity;
				var price = theme.Currency.formatMoney(item.price, theme.settings.moneyFormat);
				var helperPrice = item.price;

				if (personCount === '2') {
					helperQuantity = Number(helperQuantity) / 2;
					helperPrice = Number(helperPrice) * 2;
					helperPrice = theme.Currency.formatMoney(helperPrice, theme.settings.moneyFormat);
				} else if (personCount === '3') {
					helperQuantity = Number(helperQuantity) / 3;
					helperPrice = Number(helperPrice) * 3;
					helperPrice = theme.Currency.formatMoney(helperPrice, theme.settings.moneyFormat);
				} else {
					helperPrice = price;
				}

				var priceTotal = theme.Currency.formatMoney(item.price * item.quantity, theme.settings.moneyFormat);
				priceInTotal += item.price * item.quantity;
				var htmlItem =
					"<div class='line-item product'>" +
					"<span class='title'>" +
					item.title +
					'</span>' +
					"<span class='quantity'>" +
					helperQuantity +
					' kpl' +
					'</span>' +
					"<span class='unit-price'>" +
					helperPrice +
					' / ruoka' +
					'</span>' +
					"<span class='price_total'>" +
					priceTotal +
					'</span>' +
					'</div>';
				htmlElements.push(htmlItem);
				totalProductCount += item.quantity;
			});

			var cartHeader =
				"<div class='line-item'>" +
				"<span class='title'>" +
				'Tuote' +
				'</span>' +
				"<span class='quantity'>" +
				'Määrä' +
				'</span>' +
				"<span class='unit-price'>" +
				'Hinta' +
				'</span>' +
				"<span class='price_total'>" +
				'Yhteensä' +
				'</span>' +
				'</div>';
			theme.omaValinta.elements.selectedItems.innerHTML += cartHeader;
			htmlElements.forEach(function (html) {
				theme.omaValinta.elements.selectedItems.innerHTML += html;
			});

			priceInTotal = theme.Currency.formatMoney(priceInTotal, theme.settings.moneyFormat);
			theme.omaValinta.elements.productsTotal.innerHTML = priceInTotal;
			if (personCount === '2') {
				theme.omaValinta.elements.selectedProductQty.innerHTML = Number(totalProductCount) / 2;
				theme.omaValinta.elements.footerTextFoodCount.innerHTML = Number(totalProductCount) / 2;
				theme.omaValinta.elements.floatingCartTotalQty.innerHTML = Number(totalProductCount) / 2;
			} else if (personCount === '3') {
				theme.omaValinta.elements.selectedProductQty.innerHTML = Number(totalProductCount) / 3;
				theme.omaValinta.elements.footerTextFoodCount.innerHTML = Number(totalProductCount) / 3;
				theme.omaValinta.elements.floatingCartTotalQty.innerHTML = Number(totalProductCount) / 3;
			} else {
				theme.omaValinta.elements.selectedProductQty.innerHTML = totalProductCount;
				theme.omaValinta.elements.footerTextFoodCount.innerHTML = totalProductCount;
				theme.omaValinta.elements.floatingCartTotalQty.innerHTML = totalProductCount;
			}
			theme.omaValinta.elements.footerPersonCount.innerHTML = Number(personCount) * 2;
			theme.omaValinta.elements.footerTextPersonCount.innerHTML = Number(personCount) * 2;

			theme.omaValinta.elements.floatingCartPeople.innerHTML = Number(personCount) * 2;
			theme.omaValinta.elements.floatingCartPrice.innerHTML = priceInTotal;
		},
		updateCart: function (variant_id, quantity, loop, grouped) {
			var data = {};
			data = {
				quantity: quantity,
				id: variant_id,
			};

			if (grouped && grouped === true) {
				data['properties[_Group]'] = true;
			}

			data = JSON.stringify(data);
			fetch('/cart/add.js', {
				method: 'POST',
				body: data,
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest',
				},
			})
				.then((response) => response.json())
				.then(function (data) {
					// console.log(data.status);
					if (data.status === 422) {
						this.error(data);
					} else {
						if (!loop || loop == false) {
							// empty
						} else {
							theme.omaValinta.addToCart();
						}
					}
				});

			/*
            var request = new XMLHttpRequest();
            request.open('POST', '/cart/add.js', true);
            request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');

            request.onload = function (e) {
                if (request.readyState === 4) {
                  if (request.status === 200 ) {
                    if ( !loop || loop == false ) {
                        // empty
                      } else {
                        theme.omaValinta.addToCart();
                      }
                  } else {
                    console.error(request.statusText);
                  }
                }
              };
              request.onerror = function (e) {
                console.error(request.statusText);
              };
            request.send(JSON.stringify(data));
            */
		},
	};
	theme.omaValinta.init();
})();
